import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as AES from 'crypto-js/aes';

@Injectable({
    providedIn: 'root',
})
export class CammsCryptoService {
    encryptionKey = 'CAMMSProjectEncryptionKeyString$';

    constructor() {}

    encryptData(data: any) {
        if (data !== null) {
            const keyHash = CryptoJS.SHA256(this.encryptionKey).toString();
            let stringifyData;
            if (typeof data === 'string' || data instanceof String)
                stringifyData = data;
            else stringifyData = JSON.stringify(data);

            return AES.encrypt(stringifyData, keyHash).toString();
        }

        return '';
    }

    decryptData(data: any) {
        if (data !== null) {
            const keyHash = CryptoJS.SHA256(this.encryptionKey).toString();
            const bytes = AES.decrypt(data.toString(), keyHash);
            return bytes.toString(CryptoJS.enc.Utf8);
        }

        return '{}';
    }

    static getDecryptedKeyValue(data: any): string {
        if (data !== null) {
            let key = 'CAMMSProjectEncryptionKeyString$';
            const keyHash = CryptoJS.SHA256(key).toString();
            const bytes = AES.decrypt(data.toString(), keyHash);
            let plainText = bytes.toString(CryptoJS.enc.Utf8);
            plainText = plainText?.replaceAll('"', '');
            return plainText;
        }

        return '';
    }
}
